import { Box, BoxProps, Heading, LinkBox, LinkOverlay, Text } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ERoutes } from "Router/types";
import { ISearch } from "types";
import { SearchHeading } from "./SearchHeading";

interface Props extends BoxProps {
  suppliers: ISearch["suppliers"];
}

export const Suppliers = ({ suppliers, ...boxProps }: Props) => {
  const { t } = useTranslation();
  if (suppliers.length === 0) return null;
  return (
    <Box {...boxProps}>
      <SearchHeading>{t("Suppliers")}</SearchHeading>
      {suppliers.map((supplier) => (
        <LinkBox key={supplier.companyId} _hover={{ bg: "gray.200" }} px="1" py="2">
          <Text fontWeight="semibold">
            <LinkOverlay as={Link} to={`${ERoutes.supplier}/${supplier.companyId}`}>
              {supplier.companyName}
            </LinkOverlay>
          </Text>
        </LinkBox>
      ))}
    </Box>
  );
};
